$('input#identificator-hebrew').on('keyup', function() {
    $('.message-characters b').text( 10 - this.value.length );
});


$('.kb_buttons').each(function() {
    $(this).on('click',function() {
        var key = $(this).data('char');
        var inputter = $('input#identificator-hebrew');
        var lenghtInput = $('input#identificator-hebrew').val().length + 1;

        if( lenghtInput >= 1 && lenghtInput <= 10){
            if(key === 'bs') {
                inputter.val(inputter.val().slice(0, -1));
                $('.message-characters b').text( 10 - inputter.val().length );
            } else {
                inputter.val(inputter.val() + key);
                $('.message-characters b').text( 10 - inputter.val().length );
            }
            inputter.focus();
            return false;
        } else {
            if(key === 'bs') {
                inputter.val(inputter.val().slice(0, -1));
                $('.message-characters b').text( 10 - inputter.val().length );
            } else {
                inputter.val(inputter.val());
                $('.message-characters b').text( 10 - inputter.val().length );
            }
            inputter.focus();
            return false;
        };

        
    });
});